import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './bulk-change-asset-types-confirm-dialog.controller';
import template from './bulk-change-asset-types-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId,
    newAssetTypeId,
    assetIds,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'bulkChangeAssetTypeConfirmDialogVM',
      locals: {
        customerId,
        newAssetTypeId,
        assetIds,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.bulkChangeAssetTypesConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkChangeAssetTypesConfirmDialog', dialogService)
  .name;
